import Vue from 'vue'
const { i18n } = Vue

import AdminMaps from '@/views/AdminMaps'
import Map from '@/views/Map'
import MapDrawing from '@/views/MapDrawing'
import AdminAppointmentList from '@/views/AdminAppointmentList'
import AdminAnnouncementList from '@/views/AdminAnnouncementList'
import AdminAppointmentDetails from '@/views/AdminAppointmentDetails'
import DefaultServiceValuesList from '@/views/DefaultServiceValuesList'
import CityList from '@/views/CityList'
import HostOnboardingDetails from '@/views/HostOnboardingDetails'
import MissionList from '@/views/MissionList'
import MissionHostsProgress from '@/views/MissionHostsProgress'
import RealEstateContractList from '@/views/RealEstateContractList'
import ContractDetails from '@/views/ContractDetails'
import TransferDetails from '@/views/TransferDetails'
import PriceTable from '@/views/PriceTable'
import HostInvoicesList from '@/views/HostInvoicesList'
import PaymentList from '@/views/PaymentList'
import QuestionnaireList from '@/views/QuestionnaireList'
import QuestionnaireQuestionsDetails from '@/views/QuestionnaireQuestionsDetails'
import PartnerList from '@/views/PartnerList'
import RealEstateBranchList from '@/views/RealEstateBranchList'
import DisputeList from '@/views/dispute/DisputeList'
import DivergenceList from '@/views/divergence/DivergenceList'

// children imports
import Users from '@/views/Users'
import HostList from '@/views/HostList'
import CustomersList from '@/views/CustomersList'
import HausefulUsers from '@/views/HausefulUsers'
import ServiceProviders from '@/views/ServiceProviders'
import ServiceProviderDetails from '@/views/serviceProvider/components/ServiceProviderDetails.vue'

import Invoices from '@/views/Invoices'
import HausefulInvoices from '@/views/invoices/hauseful/HausefulInvoices'
import AdminInvoicesHosts from '@/views/invoices/admin/AdminInvoicesHosts'

import RentOut from '@/views/RentOut'
import CategoryList from '@/views/CategoryList'
import ItemList from '@/views/ItemList'
import VendorsList from '@/views/VendorsList'
import SplitConfigurationList from '@/views/SplitConfigurationList'
import Financial from '@/views/Financial'
import AdminMovementList from '@/views/movement/AdminMovementList'
import AdminRecharge from '@/views/AdminRecharge'
import TransferList from '@/views/TransferList'
import FinancialReports from '@/views/financialReport/FinancialReports'

export const adminRoute = [
  {
    path: '/map',
    name: 'adminMap',
    component: AdminMaps,
    meta: {
      login: true,
      title: i18n.translate('pages.title.maps'),
      icon: 'mdi-map-marker-radius-outline',
      roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_OPERATOR', 'ROLE_SUPPORT'],
    },
    children: [
      {
        path: '/operation-map',
        name: 'adminOperationMap',
        component: Map,
        meta: {
          login: true,
          title: i18n.translate('pages.title.operationMap'),
          icon: 'mdi-office-building-marker',
          roles: ['ROLE_ADMIN', 'ROLE_SUPPORT'],
          childrenOf: 'adminMap',
        },
      },
      {
        path: '/group-map',
        name: 'adminGroupMap',
        component: MapDrawing,
        meta: {
          login: true,
          title: i18n.translate('pages.title.groupMap'),
          icon: 'mdi-map-marker-multiple',
          roles: ['ROLE_ADMIN', 'ROLE_SUPPORT'],
          childrenOf: 'adminMap',
        },
      },
    ],
  },

  {
    path: '/admin-appointments',
    name: 'adminAppointmentsList',
    component: AdminAppointmentList,
    meta: {
      login: true,
      title: i18n.translate('pages.title.appointmentList'),
      icon: 'mdi-calendar-month',
      roles: ['ROLE_ADMIN', 'ROLE_PEOPLE', 'ROLE_HAUSEFUL_OPERATOR', 'ROLE_SUPPORT'],
    },
  },

  {
    path: '/disputes',
    name: 'adminDisputes',
    component: DisputeList,
    meta: {
      login: true,
      title: i18n.translate('pages.title.disputeList'),
      icon: 'mdi-text-box-search-outline',
      roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_OPERATOR'],
    },
  },

  {
    path: '/divergences',
    name: 'adminDivergences',
    component: DivergenceList,
    meta: {
      login: true,
      title: i18n.translate('pages.title.divergenceList'),
      icon: 'mdi-calculator-variant-outline',
      roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_FINANCIAL', 'ROLE_HAUSEFUL_OPERATOR'],
    },
  },

  {
    path: '/admin-appointment/:id',
    name: 'adminAppointmentsDetails',
    component: AdminAppointmentDetails,
    meta: {
      login: true,
      title: i18n.translate('pages.title.appointmentDetails'),
      roles: ['ROLE_ADMIN', 'ROLE_PEOPLE', 'ROLE_HAUSEFUL_OPERATOR', 'ROLE_SUPPORT'],
    },
  },

  {
    path: '/host-appointments/:hostId',
    name: 'adminHostAppointmentsList',
    component: AdminAppointmentList,
    meta: {
      login: true,
      title: i18n.translate('pages.title.appointmentList'),
      roles: ['ROLE_ADMIN', 'ROLE_PEOPLE', 'ROLE_HAUSEFUL_OPERATOR', 'ROLE_SUPPORT'],
    },
  },

  {
    path: '/hostInvoices/:id',
    name: 'hostInvoices',
    component: HostInvoicesList,
    meta: {
      login: true,
      title: i18n.translate('pages.title.hostInvoices'),
      roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_FINANCIAL'],
    },
  },

  {
    path: '/service-providers/:id',
    name: 'serviceProviderDetails',
    component: ServiceProviderDetails,
    meta: {
      login: true,
      title: i18n.translate('pages.title.serviceProvider'),
      roles: ['ROLE_ADMIN'],
    },
  },

  {
    path: '/#',
    name: 'adminUsers',
    component: Users,
    meta: {
      login: true,
      title: i18n.translate('pages.title.users'),
      icon: 'mdi-account-group-outline',
      roles: ['ROLE_ADMIN', 'ROLE_PEOPLE', 'ROLE_HAUSEFUL_OPERATOR', 'ROLE_SUPPORT'],
    },
    children: [
      {
        path: '/hosts',
        name: 'adminHosts',
        component: HostList,
        meta: {
          login: true,
          title: i18n.translate('pages.title.hosts'),
          icon: 'mdi-badge-account-outline',
          roles: ['ROLE_ADMIN', 'ROLE_PEOPLE', 'ROLE_HAUSEFUL_OPERATOR', 'ROLE_SUPPORT'],
        },
      },
      {
        path: '/customers',
        name: 'adminCustomerList',
        component: CustomersList,
        meta: {
          login: true,
          title: i18n.translate('pages.title.customerList'),
          icon: 'mdi-account-multiple-outline',
          roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_OPERATOR', 'ROLE_SUPPORT'],
        },
      },
      {
        path: '/hauseful-users',
        name: 'hausefulUsers',
        component: HausefulUsers,
        meta: {
          login: true,
          title: i18n.translate('pages.title.hausefulUsers'),
          icon: 'mdi-shield-account-outline',
          roles: ['ROLE_ADMIN'],
        },
      },
      {
        path: '/service-providers',
        name: 'serviceProviders',
        component: ServiceProviders,
        meta: {
          login: true,
          title: i18n.translate('pages.title.serviceProviders'),
          icon: 'mdi-account-file-text-outline',
          roles: ['ROLE_ADMIN'],
        },
      },
    ]
  },

  {
    path: '/#',
    name: 'adminInvoices',
    component: Invoices,
    meta: {
      login: true,
      title: i18n.translate('pages.title.invoices'),
      icon: 'mdi-text-box-outline',
      roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_FINANCIAL'],
    },
    children: [
      {
        path: '/invoices/hauseful',
        name: 'adminHausefulInvoices',
        component: HausefulInvoices,
        meta: {
          login: true,
          title: i18n.translate('pages.title.invoicesHauseful'),
          icon: 'mdi-account-tie-outline',
          roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_FINANCIAL'],
          childrenOf: 'adminInvoices',
        },
      },
      {
        path: '/invoices/hosts',
        name: 'adminHostsInvoices',
        component: AdminInvoicesHosts,
        meta: {
          login: true,
          title: i18n.translate('pages.title.adminInvoicesHosts'),
          icon: 'mdi-account-outline',
          roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_FINANCIAL'],
        },
      },
    ],
  },

  {
    path: '/#',
    name: 'adminRentOut',
    component: RentOut,
    meta: {
      login: true,
      title: i18n.translate('pages.title.rentOut'),
      icon: 'mdi-folder-home-outline',
      roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_OPERATOR'],
    },
    children: [
      {
        path: '/categories',
        name: 'adminCategories',
        component: CategoryList,
        meta: {
          login: true,
          title: i18n.translate('pages.title.categoryList'),
          icon: 'mdi-label-multiple-outline',
          roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_OPERATOR'],
          childrenOf: 'adminRentOut',
        },
      },
      {
        path: '/items',
        name: 'adminItems',
        component: ItemList,
        meta: {
          login: true,
          title: i18n.translate('pages.title.itemList'),
          icon: 'mdi-format-list-bulleted',
          roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_OPERATOR'],
          childrenOf: 'adminRentOut',
        },
      },
      {
        path: '/vendors',
        name: 'adminVendors',
        component: VendorsList,
        meta: {
          login: true,
          title: i18n.translate('pages.title.vendorsList'),
          icon: 'mdi-account-hard-hat-outline',
          roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_OPERATOR'],
          childrenOf: 'adminRentOut',
        },
      },
      {
        path: '/split-configuration',
        name: 'adminSplitConfiguration',
        component: SplitConfigurationList,
        meta: {
          login: true,
          title: i18n.translate('pages.title.splitConfigurationList'),
          icon: 'mdi-axis-arrow',
          roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_OPERATOR'],
          childrenOf: 'adminRentOut',
        },
      },
    ],
  },

  {
    path: '/#',
    name: 'adminFinancial',
    component: Financial,
    meta: {
      login: true,
      title: i18n.translate('pages.title.financial'),
      icon: 'mdi-bank-outline',
      roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_FINANCIAL'],
    },
    children: [
      {
        path: '/admin-movements',
        name: 'adminMovements',
        icon: 'mdi-book-open-variant',
        component: AdminMovementList,
        meta: {
          login: true,
          title: i18n.translate('pages.title.movementList'),
          icon: 'mdi-book-open-variant',
          roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_FINANCIAL'],
          childrenOf: 'adminFinancial',
        },
      },
      {
        path: '/admin-recharge',
        name: 'adminRecharge',
        component: AdminRecharge,
        meta: {
          login: true,
          title: i18n.translate('pages.title.rechargeList'),
          icon: 'mdi-credit-card-sync-outline',
          roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_FINANCIAL'],
          childrenOf: 'adminFinancial',
        },
      },
      {
        path: '/admin-charge',
        name: 'adminCharge',
        component: AdminRecharge,
        meta: {
          login: true,
          title: i18n.translate('pages.title.chargeList'),
          icon: 'mdi-hand-coin-outline',
          roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_FINANCIAL'],
          childrenOf: 'adminFinancial',
        },
      },
      {
        path: '/transfers',
        name: 'adminTransfers',
        component: TransferList,
        meta: {
          login: true,
          title: i18n.translate('pages.title.transfers'),
          icon: 'mdi-cash-fast',
          roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_FINANCIAL'],
          childrenOf: 'adminFinancial',
        },
      },
      {
        path: '/payments',
        name: 'adminPaymentList',
        component: PaymentList,
        meta: {
          login: true,
          title: i18n.translate('pages.title.payments'),
          icon: 'mdi-account-credit-card-outline',
          roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_FINANCIAL'],
          childrenOf: 'adminFinancial',
        },
      },
      {
        path: '/default-service-values',
        name: 'adminDefaultServiceValues',
        component: DefaultServiceValuesList,
        meta: {
          login: true,
          title: 'Tabela de Preços',
          icon: 'mdi-briefcase-edit-outline',
          roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_FINANCIAL'],
          childrenOf: 'adminFinancial',
        },
      },
      {
        path: '/financial-reports',
        name: 'adminFinancialReports',
        component: FinancialReports,
        meta: {
          login: true,
          title: 'Relatórios Financeiros',
          icon: 'mdi-chart-bar',
          roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_FINANCIAL'],
          childrenOf: 'adminFinancial',
        },
      },
    ],
  },

  {
    path: '/missions',
    name: 'adminMissions',
    component: MissionList,
    meta: {
      login: true,
      title: i18n.translate('pages.title.missions'),
      icon: 'mdi-bullseye-arrow',
      roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_OPERATOR', 'ROLE_SUPPORT'],
    },
  },

  {
    path: '/mission-progress/:missionId',
    name: 'adminMissionProgress',
    component: MissionHostsProgress,
    props: true,
    meta: {
      login: true,
      title: i18n.translate('pages.title.missionProgress'),
      roles: ['ROLE_ADMIN'],
    },
  },

  {
    path: '/hosts/:id',
    name: 'adminHostOnboardingDetails',
    component: HostOnboardingDetails,
    meta: {
      login: true,
      title: i18n.translate('pages.title.hostOnboarding'),
      roles: ['ROLE_ADMIN', 'ROLE_PEOPLE', 'ROLE_HAUSEFUL_OPERATOR'],
    },
  },

  {
    path: '/cities',
    name: 'adminCities',
    component: CityList,
    meta: {
      login: true,
      title: i18n.translate('pages.title.cities'),
      icon: 'mdi-city-variant-outline',
      roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_OPERATOR'],
    },
  },

  {
    path: '/price-table/:id',
    name: 'adminPriceList',
    component: PriceTable,
    meta: {
      login: true,
      title: i18n.translate('pages.title.priceTable'),
      roles: ['ROLE_ADMIN'],
    },
  },

  {
    path: '/real-estate-contracts/:id',
    name: 'adminRealEstateContractList',
    component: RealEstateContractList,
    meta: {
      login: true,
      title: i18n.translate('pages.title.RealEstateContractList'),
      roles: ['ROLE_ADMIN']
    },
  },

  {
    path: '/real-estate-branches/:id',
    name: 'adminRealEstateBranchList',
    component: RealEstateBranchList,
    meta: {
      login: true,
      title: i18n.translate('pages.title.RealEstateBranchList'),
    },
  },

  {
    path: '/contract-details/:id',
    name: 'adminContractDetails',
    component: ContractDetails,
    meta: {
      login: true,
      title: i18n.translate('pages.title.contractDetails'),
      roles: ['ROLE_ADMIN'],
    },
  },

  {
    path: '/transfer/:id',
    name: 'adminTransferDetails',
    component: TransferDetails,
    meta: {
      login: true,
      title: i18n.translate('pages.title.transferDetails'),
      roles: ['ROLE_ADMIN'],
    },
  },

  {
    path: '/questionnaire',
    name: 'adminQuestionnaire',
    component: QuestionnaireList,
    meta: {
      login: true,
      title: i18n.translate('pages.title.questionnaireList'),
      icon: 'mdi-book-edit-outline',
      roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_OPERATOR', 'ROLE_SUPPORT'],
    },
  },

  {
    path: '/questionnaire/questions/:id',
    name: 'adminQuestionnaireQuestions',
    component: QuestionnaireQuestionsDetails,
    meta: {
      login: true,
      title: i18n.translate('pages.title.questionnaireQuestionsDetails'),
      roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_OPERATOR'],
    },
  },

  {
    path: '/partners',
    name: 'adminPartners',
    component: PartnerList,
    meta: {
      login: true,
      title: i18n.translate('pages.title.partners'),
      icon: 'mdi-handshake-outline',
      roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_OPERATOR'],
    },
  },

  {
    path: '/announcements',
    name: 'adminAnnouncements',
    component: AdminAnnouncementList,
    meta: {
      login: true,
      title: i18n.translate('pages.title.announcements'),
      icon: 'mdi-bullhorn-outline',
      roles: ['ROLE_ADMIN', 'ROLE_HAUSEFUL_OPERATOR', 'ROLE_SUPPORT'],
    },
  },

  {
    path: '/inspection-models',
    name: 'adminInspectionModelList',
    component: () => import('@/views/appointmentTypeChecklist/LinkedAppointmentTypeChecklists.vue'),
    meta: {
      login: true,
      title: i18n.translate('pages.title.modelsInspections'),
      icon: 'mdi-link',
      roles: ['ROLE_ADMIN'],
      order: 1,
    },
  },
]
